import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import About from '../pages/about/page';
import Services from '../pages/services/page';
import Products from '../pages/products/page';
import ProductCategory from '../pages/product-category/page';
import ProductDetail from '../pages/product-detail/page';
import Contact from '../pages/contact/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/hakkimizda',
    element: <About />
  },
  {
    path: '/hizmetler',
    element: <Services />
  },
  {
    path: '/urunler',
    element: <Products />
  },
  {
    path: '/urun-kategori/:mainCategory/:subCategory',
    element: <ProductCategory />
  },
  {
    path: '/urun/:id',
    element: <ProductDetail />
  },
  {
    path: '/iletisim',
    element: <Contact />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;